// Styles for CarouselControlls go here.
import styled from 'styled-components';

export const StyledCarouselControls = styled.div``;
